<template>
    <div class="box">
      <div class="title">
          <slot></slot>
      </div>
      <van-dropdown-menu>
          <van-dropdown-item @change="returnTime" v-model="value" :options="selectOptions" />
      </van-dropdown-menu>
    </div>
  </template>
  
  <script>
  import moment from "moment";
  export default {
    data() {
      return {
        value:'',
        STATIC: {
          timeMode:{
            day:{
              value:14, // 返回参数格式
              length:30 // 控制显示长度
            },
            week:{
              value:13,
              length:5
            },
            month:{
              value:12,
              length:3
            },
          }
        }, 
         FLAG: {
          checked:'day'
        },
      };
    },
    methods: {
      returnTime() {
        const obj = {
          time:this.value,
          timeMode:this.STATIC.timeMode[this.FLAG.checked].value
        }
        this.$emit('switchTime',obj)
      }
    },
    computed: {
      /** 下拉框待选项 **/
      selectOptions(){
        let arr = [...new Array(this.STATIC.timeMode[this.FLAG.checked].length)] //生成数组长度
        switch (this.FLAG.checked){
          case 'day' : {
           arr =  arr.map( (ele,index) => {
              return {
                text:moment().subtract(index + 1,'days').format('MM-DD'),
                value:moment().subtract(index + 1,'days').format('yyyyMMDD'),
              }
            })
            break
          }
          case 'week' : {
            arr = arr.map( (ele,index) => {
              return {
                text:`${moment().subtract(index + 1, 'isoWeeks').startOf("isoWeeks").format('MM/DD')} - ${moment().subtract(index + 1, 'isoWeeks').endOf('isoWeeks').format('MM/DD')}`,
                value:moment().subtract(index + 1,'isoWeeks').endOf('isoWeeks').format('yyyyMMDD'),
              }
            })
            break
          }
          case 'month' : {
            arr = arr.map( (ele,index) => {
              return {
                text:`${moment().subtract(index + 1, 'months').startOf("months").format('MM/DD')} - ${moment().subtract(index + 1, 'months').endOf('months').format('MM/DD')}`,
                value:moment().subtract(index + 1,'months').endOf('months').format('yyyyMMDD'),
              }
            })
            break
          }
        }
        return arr
      }
    },
    mounted() {
      this.value = this.selectOptions[0].value

      this.returnTime()
    }
  };
  </script>
  
  <style scoped lang="less">
  .box {
      width: 100vw;
      height: 46px;
      background-color: #fff;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 12px;
      // margin-bottom: 12px;
      .title {
          font-size: 14px;
          color: #696D75;
      }
      .time {
          display: flex;
          width: 150px;
          justify-content: space-between;
          align-items: center;
          height: 46px;
          .tiem_txt {
              position: relative;
              left:5px ;
          }
      }
      /deep/.van-dropdown-menu {
          height: 46px;
      }
      /deep/.van-dropdown-menu__bar {
          height: 46px;
          box-shadow: none;
      }
      /deep/.van-dropdown-menu__item {
              line-height: 46px;
              height: 46px;
          }
  }
  </style>
  